module.exports = __webpack_public_path__ + "static/c20-a1e0a9f7710a52948faee86b8a4f1a72.jpg";